import { Component, OnInit, ChangeDetectorRef, NgZone, ViewEncapsulation, HostListener, ViewChild, ElementRef } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from '@angular/fire/database';
import * as _moment from 'moment';
import { saveAs } from 'file-saver';
import { DateTimeAdapter } from 'ng-pick-datetime';
//import * as Chartist from 'chartist';
import { Chart, registerables } from 'chart.js';
import { environment } from '../../../environments/environment';
import { AntEnvService, AuthService, DataService, HelperService } from '../../_services';
import { empty, forkJoin, Observable } from 'rxjs';
import { UAParser } from 'ua-parser-js'; 

import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  //styleUrls: ['./dashboard.component.tp.css'],
  styleUrls: ['./dashboard.component.css'],
  //encapsulation : ViewEncapsulation.Native
  //changeDetection: ChangeDetectionStrategy.Default
})
export class DashboardComponent implements OnInit {
  @ViewChild('chtLineEntry', {read:null, static:false}) chtLineEntry: ElementRef;
  @ViewChild('chtLineExit', {read:null, static:false}) chtLineExit: ElementRef;
  @ViewChild('chtLineOccupancy', {read:null, static:false}) chtLineOccupancy: ElementRef;
  @ViewChild('chtLineHourlyDwellTime', {read:null, static:false}) chtLineHourlyDwellTime: ElementRef;
  @ViewChild('pdfTable') pdfTable: ElementRef;
  public selectedMoment = new Date();//2021,3,26);

  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    public svcAuth: AuthService,
    public svcData: DataService,
    dateTimeAdapter: DateTimeAdapter<any>,
    private svcAntEnv: AntEnvService,
    private svcHelper: HelperService,
    private router: Router
  ) { 
    //dateTimeAdapter.setLocale('fr-FR'); // change locale to Japanese
    Chart.register(...registerables);
  }
  @HostListener('click', ['$event']) onClick(e) {
    if(e.target.classList.contains('li_area')){
      this.pageData.areaIndex = -1;
      var _title = e.target.innerHTML;
      this.pageData.areas.forEach((rec, iRec)=>{
        if(_title == rec.title){
          this.pageData.areaIndex = iRec
        }
      });
    }
  }
  client = '';
  pageData = {
    account: {
      //fullName: '', email: '', password: '', confirmPassword: '', contactNo: '', imageUrl: '', role: 'ADMIN', title: ''
      fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    userList: [], areas:[], areas4Occupancy:[],
    areaIndex: -1, inValue: 0, outValue: 0, occupancyValue: 0,
    data: [], hourlyDtd:[],
    cDataEntry: [], cDataExit: [], cDataOccupancy: [], cHourlyDTD: [],
    cHisEntry:[], cHisExit: [], cHisOccupancy: [],
    autoRefresh: false, isToday: false, maxOccupancy: 0
  }
  dataHis = {
    data: [], peakHourTitle: '-',
    inValue: 0, outValue: 0, maxOccupancy: 0
  };
  isLoading = true; isLoadingOccupancy = false;
  area:any;
  chtEntry:any;
  chtExit:any;
  chtOccupancy:any;
  chtHourlyDwellTime:any;
  peakHourTitle = '-';
  dwelltimeMinute = 0;
  dwelltimeMinuteLastWeek = 0;
  isShowDTD = false;
  isShowDTDGH = true;
  ImageBaseData: string | ArrayBuffer;
  imgPath: any;
  dwellTimeGH: any = [];
  avgArrDwellTime: any = {rowCount: 0, dwellTimeSec: 0};
  maxDwellTime: any = 0;
  avgDwellTime: any = 0;
  tpClosingTime: any = '025959';

  ngOnInit() {
    var user = this.svcAuth.getCurrentUser();
    if(user != null){
      this.svcData.checkSession(user).subscribe(res => {
        if(res == 0){
          this.router.navigate(['/login']);
        }
      });
    }
    // var _browserAgent = Bowser.parse(window.navigator.userAgent);
    // var _isMobile = _browserAgent.platform != null && _browserAgent.platform.type == 'mobile';
    // var _browser = _browserAgent.browser == null ? 'NA' : `${_browserAgent.browser.name} ${_browserAgent.browser.version}`;
    // var _productCode = 'xxx';
    // var _info = `type:NA;navi:${_browser};isMobile:${_isMobile?'Y':'N'};productCode:${_productCode};`;
    let parser = new UAParser();
    console.log('ua-parser', parser.getResult());
    //console.log('navigator: ', navigator.userAgent);
    this.svcAntEnv.load().subscribe(res=>{
      if(res.client != null){
          this.client = res.client;
      }
    });
    this.areaListLoad();

    var _self = this;
    window.setInterval(
      function(){ 
        if(_self.pageData.autoRefresh){
          console.log('auto-refresh');
          _self.dataLoad();
        }
      },
      (environment.autoRefreshSec*1000)
    );
  }
  ngAfterViewInit(){
    //console.log('this is ngAfterViewInit');
    //console.log(JSON.parse(localStorage.getItem("currentUser")).userId);
    this.svcData.usageAdd('{"userId":"'+JSON.parse(localStorage.getItem("currentUser")).userId+'","code":"DASHBOARD-VIEW","actionCode":"DASHBOARD-VIEW"}').subscribe();
  }
  areaListLoad(){
    this.svcData.areaListForDashboard().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      //console.log(res.data);
      this.pageData.areas = res.data;
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      this.areaSelect(this.pageData.areas[0]);
      setTimeout(function(){
        M.FormSelect.init(document.querySelectorAll('select'), {classes:'ddl-001'});
      }, 3000);
    });
  }

  public downloadAsPDF(chtName:string) {
    const canvas = <HTMLCanvasElement> document.getElementById(chtName);
    const tblSkill = document.getElementById('pdf'+chtName);
    const canvasImage = canvas.toDataURL('image/jpeg', 1.0);
    
    // var ctx = canvas.getContext("2d");
    // ctx.fillStyle = "grey";
    // ctx.fillRect(0, 0, canvas.width, canvas.height);
    // const canvasImage = canvas.toDataURL('image/jpeg', 1.0);

    let pdf = new jsPDF();
    pdf.setFontSize(12);
    pdf.setDrawColor(204, 204,204,0);
    //pdf.rect(10, 10, 150, 160, "F");
    //console.log(canvas.width);
    pdf.addImage(canvasImage, 'png', 5, 5, tblSkill.clientWidth*0.15, canvas.height*0.2);
    pdf.save(chtName+'.pdf');

    // const doc = new jsPDF();
    
    // const pdfTable = this.chtLineEntry.nativeElement;
    
    // var html = htmlToPdfmake(pdfTable.innerHTML);
      
    // const documentDefinition = { content: html };
    // pdfMake.createPdf(documentDefinition).open(); 
      
  }


  dataLoad(){
    this.loading(true);
    this.svcData.areaDetail(this.area.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      var _areaDetail = res.data;
      //console.log(_areaDetail);
      //this.ImageBaseData = _areaDetail.imgB64.toString(); // dbimg
      var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
      
      this.pageData.isToday = _startTime == _moment().format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      this.pageData.maxOccupancy = 0;
      var _startTimeLastWeek = _moment(this.selectedMoment).subtract(7,'d').format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      
      this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          console.log('sensor data error### ' + this.area.areaId);
          this.showAlert(res.message);
          return;
        }
        this.pageData.inValue = 0;
        this.pageData.outValue = 0;        
        this.pageData.data = res.data;
        //console.log(this.pageData.data);
  
        this.pageData.cDataEntry = [];
        this.pageData.cDataExit = [];
        this.pageData.cDataOccupancy = [];
  
        var cIntervals = this.chartIntervals(this.area.openingTime, this.area.closingTime);
        var cHour = _moment().hour();
        cIntervals.forEach(x=>{
          this.pageData.cDataEntry.push(null);
          this.pageData.cDataExit.push(null);
          this.pageData.cDataOccupancy.push(null);
        });
        var _openingHour = _moment(this.area.openingTime).hour();
        this.pageData.data.forEach(x=>{
          this.pageData.inValue +=  x.inValue;
          this.pageData.outValue += x.outValue;
          
          var iHour = _moment(x.timestamp).hour()-_openingHour;
          if(this.pageData.isToday && iHour>cHour){
            this.pageData.cDataEntry[iHour] = null;
            this.pageData.cDataExit[iHour] = null;
          }
          else{
            this.pageData.cDataEntry[iHour] = x.inValue;
            this.pageData.cDataExit[iHour] = x.outValue;
          }
        });
        if(this.pageData.inValue<this.pageData.outValue){
          this.pageData.outValue = this.pageData.inValue;
        }
        var _occupancy = 0;
        this.pageData.cDataEntry.forEach((x, iX)=>{
          if(x==null && this.pageData.cDataExit[iX]==null) return;
          _occupancy += x - this.pageData.cDataExit[iX];
          if(_occupancy<0) _occupancy = 0;
          if(this.pageData.isToday && cHour<iX) _occupancy = null;
          this.pageData.cDataOccupancy[iX] = _occupancy;
          if(_occupancy>this.pageData.maxOccupancy) this.pageData.maxOccupancy = _occupancy;
        })
        //this.pageData.occupancyValue = this.pageData.inValue - this.pageData.outValue;
        if(this.pageData.occupancyValue<0) this.pageData.occupancyValue = 0;
  
        this.dataLoadHistory(_areaDetail);
        //this.loadHourlyDwellTimeData(_startTime, _endTime, this.area.areaId);
        this.chartBind();
        //this.loadSensorLocation(this.area.areaId);
        this.dataLoadPeakHour();
        // if(this.svcHelper.showHideDwellTime == true){
        //   this.loadDwellTimeData(_startTime);
        //   this.loadDwellTimeDataLastWeek(_startTimeLastWeek);
        // }
        if(!this.pageData.isToday){
          this.pageData.outValue = this.pageData.inValue;
          this.pageData.occupancyValue = 0;
        }
      });
      if(this.pageData.isToday){
        this.dataLoad4Occupancy();
      }
      else{
        this.pageData.areas4Occupancy = [];
      }
    });
    this.getDwellTimeDataGH(this.area.areaId, _moment(this.selectedMoment).format('YYYYMMDD')+'000000'); // DwellTimeGH
  }
  dataLoadHistory(_areaDetail){
    var _startTime = _moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
    var _endTime = _moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
    this.dataHis.inValue = 0;
    this.dataHis.outValue = 0;
    this.dataHis.maxOccupancy = 0;
    this.dataHis.peakHourTitle = '-';
    var _maxIn = 0;
    var _occupancy = 0;
    this.pageData.cHisEntry = [];
    this.pageData.cHisExit = [];
    this.pageData.cHisOccupancy = [];

    this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataHis.data = res.data;
      this.dataHis.data.forEach(d=>{
        this.dataHis.inValue += d.inValue;
        this.dataHis.outValue += d.outValue;
        if(d.inValue > _maxIn){
          _maxIn = d.inValue;
          this.dataHis.peakHourTitle = _moment(d.timestamp).format('hh A');
        }
        _occupancy += d.inValue - d.outValue;
        if(_occupancy<0) _occupancy = 0;
        if(_occupancy>this.dataHis.maxOccupancy) this.dataHis.maxOccupancy = _occupancy;

        this.pageData.cHisEntry.push(d.inValue);
        this.pageData.cHisExit.push(d.outValue);
        this.pageData.cHisOccupancy.push(_occupancy);
      });
      this.chartBind();
    });
  }
  dataLoadPeakHour(){
    this.peakHourTitle = '-';
    var _maxIn = 0;
    this.pageData.data.forEach(d=>{
      if(d.inValue > _maxIn){
        _maxIn = d.inValue;
        this.peakHourTitle = _moment(d.timestamp).format('hh A');
      }
    });
  }
  dataLoad4Occupancy(){
    this.pageData.areas4Occupancy = [];
    this.svcData.areaListForOccupancy().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;

      var _arrReq:Observable<any>[] = [];
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.openingTime).format('HHmmss');
        var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.closingTime).format('HHmmss');
        _arrReq.push(this.svcData.sensorData(rec.areaId, _startTime, _endTime));
      });
      this.isLoadingOccupancy = true;
      forkJoin(_arrReq).subscribe(resArr=>{
        this.isLoadingOccupancy = false;
        resArr.forEach((resOccupancy, i)=>{
          if(resOccupancy.status != 'OK'){
            this.showAlert(resOccupancy.message);
            return;
          }
          var _areaOccupancy = 0;
          var _dataOccupancy = resOccupancy.data;

          // this.pageData.cDataEntry = [];
          // this.pageData.cDataExit = [];
          // this.pageData.cDataOccupancy = [];
          //console.log(i, resOccupancy);
          this.pageData.areas4Occupancy[i].inTotal = 0;
          this.pageData.areas4Occupancy[i].outTotal = 0;
          _dataOccupancy.forEach(x=>{
            _areaOccupancy += x.inValue - x.outValue;
            this.pageData.areas4Occupancy[i].inTotal += x.inValue;
            this.pageData.areas4Occupancy[i].outTotal += x.outValue;
            if(_areaOccupancy<0) _areaOccupancy = 0;
          });
          this.pageData.areas4Occupancy[i].occupancy = _areaOccupancy;
          this.pageData.areas4Occupancy[i].occupancyTitle = _areaOccupancy;
        });
        //console.log('this.client', this.client);
        if(this.client == 'DM'){
          //console.log('DM>>>', this.pageData.areas4Occupancy[0]);
          //this.pageData.areas4Occupancy[0].inTotal = 100;
          if(this.pageData.areas4Occupancy[0].occupancy<=0 && this.pageData.areas4Occupancy[0].inTotal>0){
            this.pageData.areas4Occupancy[0].occupancy = Math.round(this.pageData.areas4Occupancy[0].inTotal*0.01);
            this.pageData.areas4Occupancy[0].occupancyTitle = this.pageData.areas4Occupancy[0].occupancy;
          }
          //console.log(this.pageData.areas4Occupancy);
          //var _occBD = this.pageData.areas4Occupancy[0].occupancy;
          // var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // L1
          // var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // LG
          // if(_occBD < _occ1 + _occ2){
          //   console.log('BD:', _occBD, 'L1:', _occ1, 'L2:', _occ2);
          //   var _tmpOccupancy = _occBD - _occ1;
          //   if(_tmpOccupancy<0) _tmpOccupancy = 0;
          //   this.pageData.areas4Occupancy[2].occupancy = _tmpOccupancy;
          //   this.pageData.areas4Occupancy[2].occupancyTitle = this.pageData.areas4Occupancy[2].occupancy;

          //   if(this.pageData.areas4Occupancy[1].occupancy> this.pageData.areas4Occupancy[0].occupancy){
          //     this.pageData.areas4Occupancy[1].occupancy = _occBD;
          //     this.pageData.areas4Occupancy[1].occupancyTitle = _occBD;
          //   }
          // }
        }
        else if(this.client == 'TB'){
          var _occBD = this.pageData.areas4Occupancy[0].occupancy;
          var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // MH
          var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // R
          var _occ3 = this.pageData.areas4Occupancy[3].occupancy; // SR
          this.pageData.areas4Occupancy[0].occupancy = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[0].occupancyTitle = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[1].occupancyTitle = _occ1;
          this.pageData.areas4Occupancy[2].occupancyTitle = _occ2;
          this.pageData.areas4Occupancy[3].occupancyTitle = _occ3;
          console.log('occupancy TB loaded>>>>', this.pageData.areas4Occupancy[0]);
        }
      })
    });
  }
  dataLoad4OccupancyV02(){
    this.pageData.areas4Occupancy = [];
    this.svcData.areaListForOccupancy().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;
      var _loadedOA = 0;
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.openingTime).format('HHmmss');
        var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.closingTime).format('HHmmss');

        var _areaOccupancy = 0;
        this.svcData.sensorData(rec.areaId, _startTime, _endTime).subscribe(resOccupancy=>{
          _loadedOA++;
          if(resOccupancy.status != 'OK'){
            this.showAlert(resOccupancy.message);
            return;
          }
          
          var _dataOccupancy = resOccupancy.data;

          // this.pageData.cDataEntry = [];
          // this.pageData.cDataExit = [];
          // this.pageData.cDataOccupancy = [];

          var _inValue = 0, _outValue = 0;
          _dataOccupancy.forEach(x=>{
            _areaOccupancy += x.inValue - x.outValue;
            if(_areaOccupancy<0) _areaOccupancy = 0;
          });
          rec.occupancy = _areaOccupancy;
          //rec.occupancyTitle = rec.occupancy;
            //console.log('DMS - Occupancy', this.pageData.areas4Occupancy);
          if(_loadedOA == 3){  //-- DMS
            console.log('DMS - Occupancy');
            // console.log(this.pageData.areas4Occupancy);
            if(this.client == 'DM'){
              //console.log(this.pageData.areas4Occupancy);
              var _occBD = this.pageData.areas4Occupancy[0].occupancy;
              var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // L1
              var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // LG
              if(_occBD < _occ1 + _occ2){
                console.log('BD:', _occBD, 'L1:', _occ1, 'L2:', _occ2);
                var _tmpOccupancy = _occBD - _occ1;
                if(_tmpOccupancy<0) _tmpOccupancy = 0;
                this.pageData.areas4Occupancy[2].occupancy = _tmpOccupancy;
                this.pageData.areas4Occupancy[2].occupancyTitle = this.pageData.areas4Occupancy[2].occupancy;

                if(this.pageData.areas4Occupancy[1].occupancy> this.pageData.areas4Occupancy[0].occupancy){
                  this.pageData.areas4Occupancy[1].occupancy = _occBD;
                  this.pageData.areas4Occupancy[1].occupancyTitle = _occBD;
                }
              }
            }
          }
          else if(this.client == 'TBz' && _loadedOA == 4){
            var _occBD = this.pageData.areas4Occupancy[0].occupancy;
            var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // MH
            var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // R
            var _occ3 = this.pageData.areas4Occupancy[3].occupancy; // SR
            console.log('TB occ: ');
            console.log('B: ' + _occBD);
            console.log('MH: ' + _occ1);
            console.log('R: ' + _occ2);
            console.log('SR: ' + _occ3);
            if(_occBD < _occ1 + _occ3){ // 20191116:put MH as 1st priority.
              console.log('case A');
              var _tmpSr = _occBD - _occ1;
              if(_tmpSr<0) _tmpSr = 0;
              this.pageData.areas4Occupancy[3].occupancy = _tmpSr;
              this.pageData.areas4Occupancy[3].occupancyTitle = _tmpSr;
              if(_occBD < _occ1){
                this.pageData.areas4Occupancy[1].occupancy = _occBD;
                this.pageData.areas4Occupancy[1].occupancyTitle = _occBD;
              }

              this.pageData.areas4Occupancy[2].occupancy = 0;
              this.pageData.areas4Occupancy[2].occupancyTitle = 0;
            }
            // if(_occBD < _occ1 + _occ3){
            //   var _tmpMh = _occBD - _occ3;
            //   if(_tmpMh<0) _tmpMh = 0;
            //   this.pageData.areas4Occupancy[1].occupancy = _tmpMh;
            //   this.pageData.areas4Occupancy[1].occupancyTitle = _tmpMh;
            //   if(_occBD < _occ3){
            //     this.pageData.areas4Occupancy[3].occupancy = _occBD;
            //     this.pageData.areas4Occupancy[3].occupancyTitle = _occBD;
            //   }

            //   this.pageData.areas4Occupancy[2].occupancy = 0;
            //   this.pageData.areas4Occupancy[2].occupancyTitle = 0;
            // }
            else if(_occBD < _occ1 + _occ2 + _occ3){
              console.log('case B');
              var _tmpR = _occBD - (_occ1 + _occ3);
              if(_tmpR<0) _tmpR = 0;
              this.pageData.areas4Occupancy[2].occupancy = _tmpR;
              this.pageData.areas4Occupancy[2].occupancyTitle = _tmpR;
            }
            
            if(this.pageData.areas4Occupancy[2].occupancy == 0){
              console.log('case C');
              if(this.pageData.areas4Occupancy[1].occupancy>this.pageData.areas4Occupancy[3].occupancy){
                //console.log(this.pageData.areas4Occupancy[1].occupancy);
                var v20 = Math.round(this.pageData.areas4Occupancy[1].occupancy * 0.15);
                var v80 = this.pageData.areas4Occupancy[1].occupancy - v20;

                this.pageData.areas4Occupancy[2].occupancy = v20;
                this.pageData.areas4Occupancy[2].occupancyTitle = v20;
                this.pageData.areas4Occupancy[1].occupancy = v80;
                this.pageData.areas4Occupancy[1].occupancyTitle = v80;

                console.log(v20);
                console.log(v80);
              }
              else //if(this.pageData.areas4Occupancy[3].occupancy>this.pageData.areas4Occupancy[1].occupancy)
              {
                //console.log(this.pageData.areas4Occupancy[3].occupancy);
                var v20 = Math.round(this.pageData.areas4Occupancy[3].occupancy * 0.15);
                var v80 = this.pageData.areas4Occupancy[3].occupancy - v20;

                this.pageData.areas4Occupancy[2].occupancy = v20;
                this.pageData.areas4Occupancy[2].occupancyTitle = v20;
                this.pageData.areas4Occupancy[3].occupancy = v80;
                this.pageData.areas4Occupancy[3].occupancyTitle = v80;

                console.log(v20);
                console.log(v80);
              }
            }
          }
          else if(this.client == 'TB' && _loadedOA==4){
            var _occBD = this.pageData.areas4Occupancy[0].occupancy;
            var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // MH
            var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // R
            var _occ3 = this.pageData.areas4Occupancy[3].occupancy; // SR
            this.pageData.areas4Occupancy[0].occupancy = _occ1+_occ2+_occ3;
            this.pageData.areas4Occupancy[0].occupancyTitle = _occ1+_occ2+_occ3;
            this.pageData.areas4Occupancy[1].occupancyTitle = _occ1;
            this.pageData.areas4Occupancy[2].occupancyTitle = _occ2;
            this.pageData.areas4Occupancy[3].occupancyTitle = _occ3;
            console.log('occupancy TB loaded>>>>', this.pageData.areas4Occupancy[0]);
          }
        });
      });
    });
  }
  dataLoad4OccupancyV01(){
    this.pageData.areas4Occupancy = [];
    //console.log('today');
    this.svcData.areaListForOccupancy().subscribe(res=>{
      //console.log(res);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;
      var _loadedOA = 0;
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.openingTime).format('HHmmss');
        var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.closingTime).format('HHmmss');

        var _areaOccupancy = 0;
        this.svcData.sensorData(rec.areaId, _startTime, _endTime).subscribe(resOccupancy=>{
          _loadedOA++;
          if(resOccupancy.status != 'OK'){
            this.showAlert(resOccupancy.message);
            return;
          }
          
          var _dataOccupancy = resOccupancy.data;

          // this.pageData.cDataEntry = [];
          // this.pageData.cDataExit = [];
          // this.pageData.cDataOccupancy = [];

          var _inValue = 0, _outValue = 0;
          _dataOccupancy.forEach(x=>{
            _areaOccupancy += x.inValue - x.outValue;
            if(_areaOccupancy<0) _areaOccupancy = 0;
          });
          rec.occupancy = _areaOccupancy;
          rec.occupancyTitle = rec.occupancy;
          //console.log(`Client: ${this.client}`);
          if(_loadedOA == 3){  //-- DMS
            // console.log('DMS - Occupancy');
            // console.log(this.pageData.areas4Occupancy);
            if(this.client == 'DM'){
              //console.log(this.pageData.areas4Occupancy);
              var _occBD = this.pageData.areas4Occupancy[0].occupancy;
              var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // L1
              var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // LG
              if(_occBD < _occ1 + _occ2){
                var _tmpOccupancy = _occBD - _occ1;
                if(_tmpOccupancy<0) _tmpOccupancy = 0;
                this.pageData.areas4Occupancy[2].occupancy = _tmpOccupancy;
                this.pageData.areas4Occupancy[2].occupancyTitle = this.pageData.areas4Occupancy[2].occupancy;

                if(this.pageData.areas4Occupancy[1].occupancy> this.pageData.areas4Occupancy[0].occupancy){
                  this.pageData.areas4Occupancy[1].occupancy = _occBD;
                  this.pageData.areas4Occupancy[1].occupancyTitle = _occBD;
                }
              }
            }
          }
          else if(this.client == 'TBz' && _loadedOA == 4){
            var _occBD = this.pageData.areas4Occupancy[0].occupancy;
            var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // MH
            var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // R
            var _occ3 = this.pageData.areas4Occupancy[3].occupancy; // SR
            console.log('TB occ: ');
            console.log('B: ' + _occBD);
            console.log('MH: ' + _occ1);
            console.log('R: ' + _occ2);
            console.log('SR: ' + _occ3);
            if(_occBD < _occ1 + _occ3){ // 20191116:put MH as 1st priority.
              console.log('case A');
              var _tmpSr = _occBD - _occ1;
              if(_tmpSr<0) _tmpSr = 0;
              this.pageData.areas4Occupancy[3].occupancy = _tmpSr;
              this.pageData.areas4Occupancy[3].occupancyTitle = _tmpSr;
              if(_occBD < _occ1){
                this.pageData.areas4Occupancy[1].occupancy = _occBD;
                this.pageData.areas4Occupancy[1].occupancyTitle = _occBD;
              }

              this.pageData.areas4Occupancy[2].occupancy = 0;
              this.pageData.areas4Occupancy[2].occupancyTitle = 0;
            }
            // if(_occBD < _occ1 + _occ3){
            //   var _tmpMh = _occBD - _occ3;
            //   if(_tmpMh<0) _tmpMh = 0;
            //   this.pageData.areas4Occupancy[1].occupancy = _tmpMh;
            //   this.pageData.areas4Occupancy[1].occupancyTitle = _tmpMh;
            //   if(_occBD < _occ3){
            //     this.pageData.areas4Occupancy[3].occupancy = _occBD;
            //     this.pageData.areas4Occupancy[3].occupancyTitle = _occBD;
            //   }

            //   this.pageData.areas4Occupancy[2].occupancy = 0;
            //   this.pageData.areas4Occupancy[2].occupancyTitle = 0;
            // }
            else if(_occBD < _occ1 + _occ2 + _occ3){
              console.log('case B');
              var _tmpR = _occBD - (_occ1 + _occ3);
              if(_tmpR<0) _tmpR = 0;
              this.pageData.areas4Occupancy[2].occupancy = _tmpR;
              this.pageData.areas4Occupancy[2].occupancyTitle = _tmpR;
            }
            
            if(this.pageData.areas4Occupancy[2].occupancy == 0){
              console.log('case C');
              if(this.pageData.areas4Occupancy[1].occupancy>this.pageData.areas4Occupancy[3].occupancy){
                //console.log(this.pageData.areas4Occupancy[1].occupancy);
                var v20 = Math.round(this.pageData.areas4Occupancy[1].occupancy * 0.15);
                var v80 = this.pageData.areas4Occupancy[1].occupancy - v20;

                this.pageData.areas4Occupancy[2].occupancy = v20;
                this.pageData.areas4Occupancy[2].occupancyTitle = v20;
                this.pageData.areas4Occupancy[1].occupancy = v80;
                this.pageData.areas4Occupancy[1].occupancyTitle = v80;

                console.log(v20);
                console.log(v80);
              }
              else //if(this.pageData.areas4Occupancy[3].occupancy>this.pageData.areas4Occupancy[1].occupancy)
              {
                //console.log(this.pageData.areas4Occupancy[3].occupancy);
                var v20 = Math.round(this.pageData.areas4Occupancy[3].occupancy * 0.15);
                var v80 = this.pageData.areas4Occupancy[3].occupancy - v20;

                this.pageData.areas4Occupancy[2].occupancy = v20;
                this.pageData.areas4Occupancy[2].occupancyTitle = v20;
                this.pageData.areas4Occupancy[3].occupancy = v80;
                this.pageData.areas4Occupancy[3].occupancyTitle = v80;

                console.log(v20);
                console.log(v80);
              }
            }
          }
        });
      });
    });
  }

  loadDwellTimeData(startTime: any){
    this.svcData.getDwellTimeData(startTime).subscribe(dw=> {
      if(dw.status != 'OK'){
        this.showAlert(dw.message);
        return;
      }      
      else{
      this.svcData.isShowDTD(this.area.areaId).subscribe(res => {
        if(dw.status != 'OK'){
          this.showAlert(res.message);
          return;
        }      
        else{
        this.isShowDTD = res.data[0].value == 1 ? true : false;
        }
      });
        if(dw.data.length>0){
          this.dwelltimeMinute = dw.data[0].dwellTimeMinute;
        }
      }
      
    })
  }

  loadDwellTimeDataLastWeek(startTime: any){
    this.svcData.getDwellTimeDataLastWeek(startTime).subscribe(dw=> {
      if(dw.status != 'OK'){
        this.showAlert(dw.message);
        return;
      }   
      if(dw.data.length>0){   
      this.dwelltimeMinuteLastWeek = dw.data[0].dwellTimeMinute;
      }
    })
  }

  dataExportCsv() {
    var cIntervals = this.chartIntervals(this.area.openingTime, this.area.closingTime);
    var _nl = '\r\n';
    var csv = _moment(this.selectedMoment).format('D/MM/YYYY') + ',';
    cIntervals.forEach((v, i) => {
      csv += v + ',';
    });
    csv += _nl;
    csv += `${this.area.areaName}${_nl}`;
    csv += `Entry,`
    cIntervals.forEach((v, i) => {
      var _v = this.pageData.cDataEntry[i];
      csv += (_v ? _v : '') + ',';
    });
    csv += `${_nl}Exit,`
    cIntervals.forEach((v, i) => {
      var _v = this.pageData.cDataExit[i];
      csv += (_v ? _v : '') + ',';
    });
    // csv += `${_nl}Occupancy,`
    // cIntervals.forEach((v, i) => {
    //   var _v = this.pageData.cDataOccupancy[i];
    //   csv += (_v ? _v : '') + ',';
    // });
    var blob = new Blob([csv], {type: 'text/csv' })
    saveAs(blob, "exportData.csv");

  }
  dateChange(){
    this.dataLoad();
  }
  areaSelect(arg){
    this.area = arg;
    this.getFPImage(this.area);
    this.dataLoad();    
  }
  areaSelectDdl(arg){
    //console.log(arg);
    //console.log(this.pageData.areas);
    var _arr = this.pageData.areas.filter(x=>x.areaName == arg);
    if(_arr.length<1){
      this.showAlert('Area not found ' + arg);
      return;
    }
    this.areaSelect(_arr[0]);
  }
  chartIntervals(openingTime, closingTime){
    var arrHr = [];
    var _startHour = _moment(openingTime).hour();
    var _endHour = _moment(closingTime).hour();
    if(_endHour==0) _endHour = 23;
    //console.log(_startHour + '~' + _endHour);
    for(var i=_startHour;i<=_endHour;i++){
      arrHr.push(i + 'hr');
    }
    return arrHr;
  }
  chartBind(){
    var _hover = { mode: 'nearest', intersect: true };
    var _tooltip = { mode: 'index', intersect: false };
    var _pluginsLegendTooltip:any = {
      legend: { display:false },
          tooltip: { mode: 'index', intersect: false }
    };
    var arrHr = this.chartIntervals(this.area.openingTime, this.area.closingTime);
    //arrHr.push(['23','24','1','2'])
    
    var _borderColorH = "rgba(224,224,224,0.5)", _bgColorH = 'rgba(117,117,117,0.1)';
    var _lblToday = 'Today', _lblLastWeek = 'Last Week', _borderHDash = [5,5];
    var _pointBorderColorH = "rgba(224,224,224,1)";

    const ctxEntry = this.chtLineEntry.nativeElement.getContext('2d');
    if(this.chtEntry != null) this.chtEntry.destroy();
    this.chtEntry = new Chart(ctxEntry, {
      type: 'line',
      data: {
        labels: arrHr,
        datasets: [
          { 
            data: this.pageData.cDataEntry, label: _lblToday, fill: true, tension: 0.5, 
            //backgroundColor : "rgba(3,169,244,0.6)", pointBorderColor:'#fff',
            backgroundColor: "rgba(33,150,243,0.2)", borderColor: "#90caf9", pointBorderColor: '#90caf9' 
          },
          { 
            data: this.pageData.cHisEntry, label: _lblLastWeek, fill: true, tension: 0.5, borderDash: _borderHDash,
            backgroundColor : _bgColorH, borderColor: _borderColorH, pointBorderColor: _pointBorderColorH //pointBorderColor:'rgba(3,169,244,0.6)',
          },
        ]
      },
      options: {
        plugins: _pluginsLegendTooltip, //hover: _hover, tooltips: _tooltip, legend: { display: false },
        maintainAspectRatio: false,
        scales: {
          //xAxes: [{ display: true }], yAxes: [{ display: true }],
        },
      }
    });
    
    const ctxExit = this.chtLineExit.nativeElement.getContext('2d');
    if(this.chtExit != null) this.chtExit.destroy();
    this.chtExit = new Chart(ctxExit, {
      type: 'line',
      data: {
        labels: arrHr,
        datasets: [
          { 
            data: this.pageData.cDataExit, label: _lblToday, fill: true, tension: 0.5,
            //backgroundColor : "rgba(255,23,68,0.6)", pointBorderColor:'#fff',
            backgroundColor: "rgba(233,30,99,0.2)", borderColor: "#ef9a9a", 
          },
          { 
            data: this.pageData.cHisExit, label: _lblLastWeek, fill: true, tension: 0.5, borderDash: _borderHDash,
            backgroundColor : _bgColorH, borderColor: _borderColorH, pointBorderColor: _pointBorderColorH
          },
        ]
      },
      options: {
        plugins: _pluginsLegendTooltip, //hover: _hover, tooltips: _tooltip, legend: { display: false },
        maintainAspectRatio: false,
        scales: {
          //xAxes: [{ display: true }], /yAxes: [{ display: true }],
        }
      }
    });

    const ctxOccupancy = this.chtLineOccupancy.nativeElement.getContext('2d');
    if(this.chtOccupancy!=null) this.chtOccupancy.destroy();
    this.chtOccupancy = new Chart(ctxOccupancy, {
      type: 'line',
      data: {
        labels: arrHr,
        datasets: [
          { 
            data: this.pageData.cDataOccupancy, label: _lblToday, fill: true, tension: 0.5,
            //backgroundColor : "rgba(205,220,57,0.6)", pointBorderColor:'#fff',
            backgroundColor: "rgba(255,193,7,0.2)", borderColor: "#ffd54f" 
          },
          { 
            data: this.pageData.cHisOccupancy, label: _lblLastWeek, fill: true, tension: 0.5, borderDash: _borderHDash,
            backgroundColor : _bgColorH, borderColor: _borderColorH, pointBorderColor: _pointBorderColorH, //pointBorderColor:'rgba(205,220,57,0.7)'
          },
        ]
      },
      options: {
        plugins: _pluginsLegendTooltip, //hover: _hover, tooltips: _tooltip,
        maintainAspectRatio: false,
        //legend: { display: false },
        scales: {
          //xAxes: [{ display: true }],
          //yAxes: [{ display: true }],
        }
      }
    });

    // const ctxHourlyDwellTime = this.chtLineHourlyDwellTime.nativeElement.getContext('2d');
    // if(this.chtHourlyDwellTime != null) this.chtHourlyDwellTime.destroy();
    // this.chtHourlyDwellTime = new Chart(ctxHourlyDwellTime, {
    //   type: 'line',
    //   data: {
    //     labels: arrHr,
    //     datasets: [
    //       { 
    //         data: this.pageData.cHourlyDTD, label: _lblToday, fill: true, tension: 0.5,
    //         backgroundColor: "rgba(153, 102, 255, 0.2)", borderColor: "#b599bf", pointBorderColor: '#b599bf' 
    //       },
    //     ]
    //   },
    //   options: {
    //     plugins: _pluginsLegendTooltip, //hover: _hover, tooltips: _tooltip, legend: { display: false },
    //     maintainAspectRatio: false,
    //     scales: {
    //     },
    //   }
    // });

  }
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  showAlert(msg){    
    M.toast({html: msg});
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
  }

  loadHourlyDwellTimeData(startTime, endTime, areaId){
    this.svcData.hourlyDwellTimeData(startTime, endTime, areaId).subscribe(hdw=>{
      this.pageData.hourlyDtd = hdw.data;
      //console.log(this.pageData.hourlyDtd);
      this.pageData.hourlyDtd.forEach(x=>{
        this.pageData.cHourlyDTD.push(x.dwellTimeMinute/60);
      })
    });
  }

  loadSensorLocation(areaId){
    this.svcData.sensorLocation(areaId).subscribe(hdw=>{
      // this.pageData.hourlyDtd = hdw.data;
      // this.pageData.hourlyDtd.forEach(x=>{
      //   this.pageData.cHourlyDTD.push(x.dwellTimeMinute/60);
      // })
      //console.log(hdw);
    });
  }

  getFPImage(argArea: any){
    this.svcData.getFPImage(argArea).subscribe(res => {
      //console.log(res);
      this.imgPath = 'data:image/png;base64,'+res.data;
    })
  }

  getDwellTimeDataGH(argArea: any, dataDate: any){
    this.dwellTimeGH = [];
    this.avgDwellTime = 0;
    this.maxDwellTime = 0;
    this.avgArrDwellTime.dwellTimeSec = 0;
    this.avgArrDwellTime.rowCount = 0;
    // console.log(_moment(this.area.openingTime).hour())
    // console.log(_moment(this.area.closingTime).hour())
    this.svcData.getHourlyDwellTimeGH(argArea, dataDate).subscribe(res => {
      if(res.status == "OK"){
        //console.log(res.data)
        res.data.forEach((dwell, i) => {
          if(dwell.localHour >= _moment(this.area.openingTime).hour() && dwell.localHour <= _moment(this.area.closingTime).hour()){
            this.dwellTimeGH.push(dwell);  
            if(this.maxDwellTime < dwell.dwellMin){
              this.maxDwellTime = dwell.dwellMin;
            }
            //this.avgArrDwellTime.rowCount = i+1;
            this.avgArrDwellTime.dwellTimeSec += dwell.dwellSec;
            //this.avgDwellTime = (this.avgArrDwellTime.dwellTimeSec);
          }
        });
        if(this.dwellTimeGH.length>0){
          this.avgDwellTime = Math.round(this.avgArrDwellTime.dwellTimeSec/this.dwellTimeGH.length/60);
        }
         //console.log(this.dwellTimeGH);
        // console.log(this.maxDwellTime);
        // console.log(this.avgArrDwellTime);
        // console.log(this.avgDwellTime);
      }
    })
  }

}
